import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@/plugins/vuex-async-pagginate';
import { GroupService } from '@pbx/services/GroupService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'name',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => GroupService.getList(params)
    }
  },
  true
);
